"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _eventTargetShim = require("../../external/event-target-shim");

var _onErrorResumeNext = _interopRequireDefault(require("on-error-resume-next"));

var _AudioContextQueue = _interopRequireDefault(require("./AudioContextQueue"));

var _createFetchAuthorizationTokenWithCache = _interopRequireDefault(require("../createFetchAuthorizationTokenWithCache"));

var _fetchCustomVoices = _interopRequireDefault(require("./fetchCustomVoices"));

var _fetchVoices = _interopRequireDefault(require("./fetchVoices"));

var _patchOptions2 = _interopRequireDefault(require("../patchOptions"));

var _SpeechSynthesisEvent = _interopRequireDefault(require("./SpeechSynthesisEvent"));

var _SpeechSynthesisUtterance = _interopRequireDefault(require("./SpeechSynthesisUtterance"));
/* eslint class-methods-use-this: 0 */
// Supported output format can be found at https://docs.microsoft.com/en-us/azure/cognitive-services/speech-service/rest-text-to-speech#audio-outputs


var DEFAULT_OUTPUT_FORMAT = 'audio-24khz-160kbitrate-mono-mp3';
var EMPTY_ARRAY = [];

var _default = function _default(options) {
  var _patchOptions = (0, _patchOptions2.default)(options),
      audioContext = _patchOptions.audioContext,
      fetchCredentials = _patchOptions.fetchCredentials,
      _patchOptions$ponyfil = _patchOptions.ponyfill,
      ponyfill = _patchOptions$ponyfil === void 0 ? {
    AudioContext: window.AudioContext || window.webkitAudioContext
  } : _patchOptions$ponyfil,
      _patchOptions$region = _patchOptions.region,
      region = _patchOptions$region === void 0 ? 'westus' : _patchOptions$region,
      speechSynthesisDeploymentId = _patchOptions.speechSynthesisDeploymentId,
      _patchOptions$speechS = _patchOptions.speechSynthesisOutputFormat,
      speechSynthesisOutputFormat = _patchOptions$speechS === void 0 ? DEFAULT_OUTPUT_FORMAT : _patchOptions$speechS,
      subscriptionKey = _patchOptions.subscriptionKey;

  if (!ponyfill.AudioContext) {
    console.warn('web-speech-cognitive-services: This browser does not support Web Audio and it will not work with Cognitive Services Speech Services.');
    return {};
  }

  var fetchAuthorizationTokenWithCache = (0, _createFetchAuthorizationTokenWithCache.default)();

  var fetchAuthorizationTokenCredentials = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _ref2, authorizationToken, region, subscriptionKey;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchCredentials();

            case 2:
              _ref2 = _context.sent;
              authorizationToken = _ref2.authorizationToken;
              region = _ref2.region;
              subscriptionKey = _ref2.subscriptionKey;

              if (!authorizationToken) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", {
                authorizationToken: authorizationToken,
                region: region
              });

            case 8:
              _context.next = 10;
              return fetchAuthorizationTokenWithCache({
                region: region,
                subscriptionKey: subscriptionKey
              });

            case 10:
              _context.t0 = _context.sent;
              _context.t1 = region;
              return _context.abrupt("return", {
                authorizationToken: _context.t0,
                region: _context.t1
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAuthorizationTokenCredentials() {
      return _ref.apply(this, arguments);
    };
  }();

  var SpeechSynthesis = /*#__PURE__*/function (_EventTarget) {
    (0, _inherits2.default)(SpeechSynthesis, _EventTarget);

    function SpeechSynthesis() {
      var _this;

      (0, _classCallCheck2.default)(this, SpeechSynthesis);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SpeechSynthesis).call(this));
      _this.queue = new _AudioContextQueue.default({
        audioContext: audioContext,
        ponyfill: ponyfill
      });

      _this.updateVoices();

      return _this;
    }

    (0, _createClass2.default)(SpeechSynthesis, [{
      key: "cancel",
      value: function cancel() {
        this.queue.stop();
      }
    }, {
      key: "getVoices",
      value: function getVoices() {
        return EMPTY_ARRAY;
      }
    }, {
      key: "pause",
      value: function pause() {
        this.queue.pause();
      }
    }, {
      key: "resume",
      value: function resume() {
        this.queue.resume();
      }
    }, {
      key: "speak",
      value: function speak(utterance) {
        var _this2 = this;

        if (!(utterance instanceof _SpeechSynthesisUtterance.default)) {
          throw new Error('invalid utterance');
        }

        return new Promise(function (resolve, reject) {
          utterance.addEventListener('end', resolve);
          utterance.addEventListener('error', reject);
          utterance.preload({
            deploymentId: speechSynthesisDeploymentId,
            fetchAuthorizationTokenCredentials: fetchAuthorizationTokenCredentials,
            outputFormat: speechSynthesisOutputFormat
          });

          _this2.queue.push(utterance);
        });
      }
    }, {
      key: "updateVoices",
      value: function () {
        var _updateVoices = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
          var _this3 = this;

          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!speechSynthesisDeploymentId) {
                    _context4.next = 7;
                    break;
                  }

                  if (!subscriptionKey) {
                    _context4.next = 5;
                    break;
                  }

                  console.warn('web-speech-cognitive-services: Listing of custom voice models are only available when using subscription key.');
                  _context4.next = 5;
                  return (0, _onErrorResumeNext.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                    var voices;
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return (0, _fetchCustomVoices.default)({
                              deploymentId: speechSynthesisDeploymentId,
                              region: region,
                              subscriptionKey: subscriptionKey
                            });

                          case 2:
                            voices = _context2.sent;

                            _this3.getVoices = function () {
                              return voices;
                            };

                          case 4:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })));

                case 5:
                  _context4.next = 9;
                  break;

                case 7:
                  _context4.next = 9;
                  return (0, _onErrorResumeNext.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
                    var _ref5, authorizationToken, region, voices;

                    return _regenerator.default.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return fetchAuthorizationTokenCredentials();

                          case 2:
                            _ref5 = _context3.sent;
                            authorizationToken = _ref5.authorizationToken;
                            region = _ref5.region;
                            _context3.next = 7;
                            return (0, _fetchVoices.default)({
                              authorizationToken: authorizationToken,
                              region: region
                            });

                          case 7:
                            voices = _context3.sent;

                            _this3.getVoices = function () {
                              return voices;
                            };

                          case 9:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  })));

                case 9:
                  this.dispatchEvent(new _SpeechSynthesisEvent.default('voiceschanged'));

                case 10:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function updateVoices() {
          return _updateVoices.apply(this, arguments);
        }

        return updateVoices;
      }()
    }, {
      key: "speaking",
      get: function get() {
        return this.queue.speaking;
      }
    }]);
    return SpeechSynthesis;
  }(_eventTargetShim.EventTarget);

  (0, _eventTargetShim.defineEventAttribute)(SpeechSynthesis.prototype, 'voiceschanged');
  return {
    speechSynthesis: new SpeechSynthesis(),
    SpeechSynthesisEvent: _SpeechSynthesisEvent.default,
    SpeechSynthesisUtterance: _SpeechSynthesisUtterance.default
  };
};

exports.default = _default;